import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RFQCard = ({ rfq, onSelect, isSelected, onStatusChange }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'in_progress':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'quoted':
        return 'bg-success/10 text-success border-success/20';
      case 'rejected':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-UG', {
      style: 'currency',
      currency: 'UGX',
      minimumFractionDigits: 0
    })?.format(amount);
  };

  return (
    <div 
      className={`p-4 border rounded-lg cursor-pointer transition-all hover:shadow-moderate ${
        isSelected ? 'border-primary bg-primary/5' : 'border-border bg-card hover:border-primary/50'
      }`}
      onClick={() => onSelect(rfq)}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-1">
            <h3 className="font-semibold text-foreground">RFQ #{rfq?.id}</h3>
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(rfq?.status)}`}>
              {rfq?.status?.replace('_', ' ')?.toUpperCase()}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-2">{rfq?.title}</p>
          <div className="flex items-center space-x-4 text-xs text-muted-foreground">
            <span className="flex items-center space-x-1">
              <Icon name="User" size={12} />
              <span>{rfq?.customer?.name}</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="Calendar" size={12} />
              <span>{formatDate(rfq?.createdAt)}</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="Clock" size={12} />
              <span>Due: {formatDate(rfq?.deadline)}</span>
            </span>
          </div>
        </div>
        <div className="flex flex-col items-end space-y-2">
          <span className={`flex items-center space-x-1 text-xs font-medium ${getPriorityColor(rfq?.priority)}`}>
            <Icon name="AlertCircle" size={12} />
            <span>{rfq?.priority?.toUpperCase()}</span>
          </span>
          {rfq?.estimatedValue && (
            <span className="text-sm font-semibold text-foreground">
              {formatCurrency(rfq?.estimatedValue)}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="text-xs text-muted-foreground">Category:</span>
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground">
            {rfq?.category}
          </span>
        </div>
        <div className="flex items-center space-x-1">
          {rfq?.assignedTo && (
            <div className="flex items-center space-x-1 text-xs text-muted-foreground">
              <Icon name="UserCheck" size={12} />
              <span>{rfq?.assignedTo}</span>
            </div>
          )}
          <Button
            variant="ghost"
            size="xs"
            onClick={(e) => {
              e?.stopPropagation();
              onStatusChange(rfq?.id, rfq?.status);
            }}
          >
            <Icon name="MoreVertical" size={14} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RFQCard;